// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Description-module--cls1--2hfY0","cls2":"styles-Description-module--cls2--32Tdb styles-Description-module--cls1--2hfY0"};